import { SelectedApp } from './selectedApp/SelectedApp';

export const MultiSelect = {
  SelectedApp,
};
